$(function() {

    // modal
    $(function() {
        var scrollPos;
        $('.js_special_modal_open').each(function() {
            $(this).on('click',function(){
                var target = $(this).data('target');
                var modal = document.getElementById(target);
                $(modal).fadeIn(500);

                var ids = $(this).data('target').split('0');
                var id = String(ids[1]);
                var name = '.' + 'slider' + 0 + id;
                var slider = $(name).slick({
                    prevArrow: '<img src="/assets/img/common/feature/arrow_prev.png" class="is_prev_arrow">',
                    nextArrow: '<img src="/assets/img/common/feature/arrow_next.png" class="is_next_arrow">'
                });
                slider.css('opacity',0);
                slider.animate({'z-index':1},300,function(){
                    slider.slick('setPosition');
                    slider.animate({'opacity':1});
                });
                $('.is_container').addClass('.is_modal_fixed').css({ top: - scrollPos });
                return false;
            });
        });
        $('.js_special_modal_close').on('click',function() {
            $('.js_special_modal').fadeOut(500);
            $('.is_container').removeClass('fixed').css({ top: 0 });
            $(window).scrollTop(scrollPos);
            return false;
        }); 
    });

    // scroll
    $(function() {
        $(window).scroll(function (){
            $('.js_scroll').each(function(){
                var targetElement = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > targetElement - windowHeight + 200){
                    $(this).css('opacity','1');
                    $(this).css('transform','translateY(0)');
                }
            });
        });
    });
    
});

// ScrollReveal
ScrollReveal().reveal('.js_scroll', { 
    duration: 1600,
    origin:'bottom',
    distance: '20px',
    reset: false   
});